<template>
  <div class="gradient-bg">
    <div class="login-box">
      <div class="login-header">请登录</div>
      <div class="form-content">

        <el-form
            ref="ruleFormRef"
            :model="ruleForm"
            :rules="rules"
            class="demo-ruleForm"
            status-icon
        >
          <el-form-item label="用户" prop="username">
            <el-input clearable v-model="ruleForm.username" />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input clearable type="password" v-model="ruleForm.password" />
          </el-form-item>
        </el-form>
        <div class="login-button" @click="submitForm(ruleFormRef)">登录</div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { getCookie, randomUUID, setCookieWithExpiration } from "@/utils/auth";
import { reactive, ref } from "vue";
import { useRouter } from 'vue-router';

const router = useRouter();
const ruleForm = reactive({
  username: "",
  password: "",
})
const ruleFormRef = ref(null)
const validateName = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('输入用户名'))
  } else {
    if (value  !== 'wudidameinv') {
      callback(new Error('用户名错误'))
    }
    callback()
  }
}
const validatePass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('输入密码'))
  } else {
    if (value  !== 'wudidameinv#') {
      callback(new Error('密码错误'))
    }
    callback()
  }
}
const rules = reactive({
  username: [{validator: validateName, trigger: 'blur' }],
  password: [{validator: validatePass, trigger: 'blur'}],
})
const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      if(getCookie('xypCookie')){
        router.push("/home")
      }else {
        setCookieWithExpiration('xypCookie', randomUUID(), 7);
        router.push("/home")
      }
    } else {
      console.log('error submit!', fields)
    }
  })
}
</script>

<style scoped>
.gradient-bg {
  height: 100vh; /* 使用视口高度 */
  background-image: linear-gradient(to right, #fbc2eb, #a6c1ee);
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-box {
  background-color: #fff;
  width: 90%; /* 使用百分比 */
  max-width: 358px; /* 设置最大宽度 */
  border-radius: 15px;
  padding: 20px; /* 增加内边距 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.login-header {
  font-size: 28px; /* 调整字体大小 */
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px; /* 增加下边距 */
}

.input-field {
  display: block;
  width: calc(100% - 20px); /* 减去左右内边距 */
  margin-bottom: 20px;
  border: 0;
  padding: 10px; /* 内边距 */
  border-bottom: 1px solid rgb(128, 125, 125);
  font-size: 15px;
  outline: none;
}

.input-field::placeholder {
  text-transform: uppercase;
}

.login-button {
  text-align: center;
  padding: 12px; /* 增加内边距 */
  margin-top: 20px;
  background-image: linear-gradient(to right, #a6c1ee, #fbc2eb);
  color: #fff;
  border-radius: 8px;
  cursor: pointer; /* 添加光标样式 */
}

.message {
  text-align: center;
  margin-top: 20px; /* 调整边距 */
}

a {
  text-decoration-line: none;
  color: #abc1ee;
}
</style>

